import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Modal,
  ModalBody,
} from "react-bootstrap";
import QRCode from "react-qr-code";
import "react-html5-camera-photo/build/css/index.css";
import { EnforcementActions, SuperAdminAction } from "../../Actions";
import { connect } from "react-redux";
import Loader from "../Loader/Loader";
import Resizer from "react-image-file-resizer";
import CustomContentAlert, { validation_message, validations } from "../helper";
import Camera, { FACING_MODES } from "react-html5-camera-photo";
import defaultImage from "../../../assets/img/plate-check.png";
import scan from "../../../assets/img/svg/scan.svg";
import ticket from "../../../assets/img/svg/ticket.svg";
import plate_check from "../../../assets/img/svg/plate_check.svg";
import { isMobile } from "react-device-detect";
import audioFileNotAllowed from "../../../assets/sound/NotAllowed.mp3";
import audioFileAllowed from "../../../assets/sound/Allowed.wav";

class Enforcement extends Component {
  constructor(props) {
    super();
    this.state = {
      properties: [
        { id: "1", name: "property1" },
        { id: "2", name: "property2" },
        { id: "3", name: "property3" },
      ],
      selectedProperty: "",
      image: "",
      // image:
      //   "https://tsrahaman.org/wp-content/uploads/2020/09/blank-user-img.jpg",
      isOpenCamera: false,
      isPlateApproved_: false,
      loader: false,
      extractedPlateNumber_: "",
      lpn: "",
      property: "",
      validPlateNumber: true,
      isFormValid: false,
      isScanEnabled: false,
      show_error: false,
      api_error_message: "",
      domain: "",
      userlots: [],
      resultSound: "",
      playSound: false,
      lotSelectionError: "",
      cameraError: "",
      stalls: [],
      stallDisabled: true,
      showScanningModal: false,
      isQREnabled: false,
      sourceUrl: "",
    };
  }

  componentDidMount = async () => {
    this.setState(
      {
        sourceUrl: `${process.env.REACT_APP_URL}`,
      },
      () => {
        console.log(this.state.sourceUrl, "sourceUrl");
      }
    );
    // }
    this.setState(
      {
        property: this.props?.property?.property_name,
        domain: this.props?.property?.domain,
        isQREnabled: this.props.property.qr_code_scanner === 1,
      },
      () => {
        const selectedPropertyName = this.state.property;
        const selectedDomainName = this.state.domain;
        this.props.setDomainHeader(selectedPropertyName, selectedDomainName);
      }
    );
    const isItRescan = this.props.location.search.split("?")[1]
      ? this.props.location.search.split("?")[1]
      : "";
    if (isItRescan && isItRescan.length) {
      this.setState({
        isOpenCamera: true,
        selectedLot: this.props.location.state.selectedLot,
        isScanEnabled: true,
      });
    }

    await this.props.getUserLots();
    if (this.props.api_response) {
      this.setState({ userlots: this.props.userlots }, () => {
        console.log("lot list", this.state.userlots);
        if (this.state.userlots && this.state.userlots.length === 1) {
          this.setState({
            selectedLot: this.state.userlots[0]?.id,
            isScanEnabled: true,
          });
        }
      });
    }
  };

  handlePlateCheck = async () => {
    this.setState({ isFormValid: true }, async () => {
      const { lpn, selectedLot, userlots, image, selectedStall } = this.state;
      await this.props.manuallyPlateCheck({
        lpn,
        selectedLot,
        selectedStall,
      });
      const scan_time =
        this.props.plateCheckData && this.props.plateCheckData.scan_time
          ? this.props.plateCheckData.scan_time
          : "";
      const tickets =
        this.props.plateCheckData &&
        this.props.plateCheckData.tickets &&
        this.props.plateCheckData.tickets.length
          ? this.props.plateCheckData.tickets
          : [];
      const result =
        this.props.plateCheckData &&
        this.props.plateCheckData.data &&
        Object.keys(this.props.plateCheckData.data).length &&
        this.props.plateCheckData.data?.result
          ? this.props.plateCheckData?.data?.result
          : "";
      const email =
        this.props.plateCheckData &&
        this.props.plateCheckData.data &&
        Object.keys(this.props.plateCheckData.data).length &&
        this.props.plateCheckData.data.email
          ? this.props.plateCheckData.data.email
          : "";
      const selectedLotDetails =
        userlots && userlots.length
          ? userlots.filter((item) => item.id === selectedLot)[0]
          : {};
      const selectedLotName =
        selectedLotDetails && Object.keys(selectedLotDetails).length
          ? selectedLotDetails.alias
          : "";
      const selectedLotCapacity =
        selectedLotDetails && Object.keys(selectedLotDetails).length
          ? selectedLotDetails.lot_capacity
          : "";
      const isVisitorLot =
        selectedLotDetails && Object.keys(selectedLotDetails).length
          ? selectedLotDetails.visitor_lot
          : false;

      const isPlateApproved = this.props.plateCheckData.isPlateApproved;
      const history = require("../../history").default;
      history.push({
        pathname: `/plate-check`,
        state: {
          image: image,
          lpn: lpn,
          isPlateApproved: isPlateApproved,
          scan_time: scan_time,
          email: email,
          data: this.props?.plateCheckData?.data,
          selectedLot: selectedLot,
          selectedLotName: selectedLotName,
          selectedLotCapacity: selectedLotCapacity,
          isVisitorLot: isVisitorLot,
          tickets: tickets,
          result: result,
          end: this.props?.plateCheckData?.end,
        },
      });
    });
  };

  handleTakePhoto = async (imageURL) => {
    const x = this.dataURLtoFile(imageURL);
    const form_data = new FormData();
    form_data.append("lot_id", this.state.selectedLot);
    console.log("this.state.selectedStall==", this.state.selectedStall);
    let stall_id;
    if (!this.state.selectedStall) {
      stall_id = null;
    } else {
      stall_id = this.state.selectedStall;
    }
    form_data.append("stall_id", stall_id);
    form_data.append("files", x);
    this.setState(
      {
        loader: true,
      },
      async () => {
        await this.props.scanPlate(form_data);
        if (this.props.api_response) {
          this.setState(
            {
              extractedPlateNumber_: this.props.extractedPlateNumber,
              lpn: this.props.extractedPlateNumber,
              loader: false,
              isOpenCamera: false,
              image: imageURL,
            },
            async () => {
              if (this.props.api_response) {
                const history = require("../../history").default;

                const { image, selectedLot, userlots } = this.state;
                const scan_time =
                  this.props.plateCheckData &&
                  this.props.plateCheckData.scan_time
                    ? this.props.plateCheckData.scan_time
                    : "";
                const tickets =
                  this.props.plateCheckData &&
                  this.props.plateCheckData.tickets &&
                  this.props.plateCheckData.tickets.length
                    ? this.props.plateCheckData.tickets
                    : [];
                const result =
                  this.props.plateCheckData &&
                  this.props.plateCheckData.data &&
                  Object.keys(this.props.plateCheckData.data).length &&
                  this.props.plateCheckData.data.result
                    ? this.props.plateCheckData.data.result
                    : "";
                const email =
                  this.props.plateCheckData &&
                  this.props.plateCheckData.data &&
                  Object.keys(this.props.plateCheckData.data).length &&
                  this.props.plateCheckData.data.email
                    ? this.props.plateCheckData.data.email
                    : "";
                const selectedLotDetails =
                  userlots && userlots.length
                    ? userlots.filter((item) => item.id === selectedLot)[0]
                    : {};
                const selectedLotName =
                  selectedLotDetails && Object.keys(selectedLotDetails).length
                    ? selectedLotDetails.alias
                    : "";
                const selectedLotCapacity =
                  selectedLotDetails && Object.keys(selectedLotDetails).length
                    ? selectedLotDetails.lot_capacity
                    : "";
                const isVisitorLot =
                  selectedLotDetails && Object.keys(selectedLotDetails).length
                    ? selectedLotDetails.visitor_lot
                    : false;
                console.log("isVisitorLot---&&&&&-", selectedLotName);

                const isPlateApproved =
                  this.props.plateCheckData.isPlateApproved;
                console.log(
                  "this.props.plateCheckData",
                  this.props.plateCheckData
                );

                history.push({
                  pathname: `/plate-check`,
                  state: {
                    image: image,
                    lpn: this.props.plateCheckData.lpn,
                    isPlateApproved: isPlateApproved,
                    scan_time: scan_time,
                    email: email,
                    data: this.props.plateCheckData.data,
                    selectedLot: selectedLot,
                    selectedLotName: selectedLotName,
                    selectedLotCapacity: selectedLotCapacity,
                    isVisitorLot: isVisitorLot,
                    tickets: tickets,
                    result: result,
                    end: this.props.plateCheckData.end,
                  },
                });
                this.setState({
                  verified: true,
                });
              } else {
                this.setState({
                  verified: false,
                  playSound: true, // need to rollback to true after pushing the code
                });
              }
              if (this.state.lpn) {
                this.setState({
                  isFormValid: true,
                  loader: false,
                });
              } else {
                this.setState({
                  isFormValid: false,
                  loader: false,
                });
              }
            }
          );
        } else {
          this.setState({
            loader: false,
            isOpenCamera: false,
            show_error: true,
            api_error_message:
              "Scan failed, please scan again or enter manually",
            verified: false,
            playSound: true,
          });
          setTimeout(() => {
            this.setState({ show_error: false, playSound: false });
          }, 4000);
        }
      }
    );
  };

  dataURLtoFile = (dataurl) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], "lpn.png", { type: mime });
  };

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1300,
        1300,
        "PNG",
        75,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });

  handleChange = (e) => {
    const lpnSpaceRemove = e.target.value.replace(/\s/g, "");
    this.setState(
      { lpn: lpnSpaceRemove.toUpperCase().replace(/[^\w\s]/gi, "") },
      async () => {
        const { lpn, selectedLot } = this.state;
        const plateNumber = validations(e.target.name, "lpn", lpn);
        this.setState({
          lpn: plateNumber.value,
          validPlateNumber: plateNumber.validator,
        });
        if (lpn && selectedLot) {
          this.setState({
            isFormValid: true,
          });
        } else {
          this.setState({
            isFormValid: false,
          });
        }
      }
    );
  };

  changeProperty = (event) => {
    console.log("changes ppppp:===", event.target.value);
    this.setState(
      {
        selectedLot: event.target.value,
      },
      () => {
        const { lpn, selectedLot } = this.state;
        if (selectedLot) {
          const stall = this.state.userlots.filter(
            (item) => item.id === this.state.selectedLot
          );
          console.log("stall:::", stall[0].permits);
          console.log("isScanEnabled", selectedLot);
          this.setState({
            stallDisabled: false,
            isScanEnabled: true,
            lotSelectionError: "",
            stalls: stall[0].permits,
          });
        } else {
          this.setState({
            lotSelectionError: "Please select lot first",
            isScanEnabled: false,
            isOpenCamera: false,
            stallDisabled: true,
          });
        }
        if (lpn && selectedLot) {
          this.setState({
            isFormValid: true,
            lotSelectionError: "",
          });
        } else {
          this.setState({
            isFormValid: false,
          });
        }
      }
    );
  };

  changeStall = (event) => {
    this.setState({
      selectedStall: event.target.value,
    });
  };

  redirectToTicket = () => {
    const history = require("../../history").default;
    history.push({
      pathname: "/citation",
      state: {
        image: "",
      },
    });
  };

  handleCameraError = (error) => {
    console.log("error", error);
    this.setState({
      cameraError: "Permission Denied",
    });
  };

  openQrModal = () => {
    const remote_url = `${this.state.sourceUrl}/photo-verify-remote?property_id=${this.props.PropertyId}&&lot_id=${this.state.selectedLot}`;
    console.log("::redirect url", remote_url);
    this.setState(
      {
        qrCodeUrl: remote_url,
      },
      () => {
        this.setState({
          showScanningModal: true,
        });
      }
    );
  };

  closeQrModal = () => {
    this.setState({
      showScanningModal: false,
    });
  };

  render() {
    const {
      image,
      lpn,
      isOpenCamera,
      loader,
      validPlateNumber,
      isFormValid,
      show_error,
      api_error_message,
      verified,
      playSound,
      isScanEnabled,
      stallDisabled,
      isQREnabled,
    } = this.state;
    return (
      <div>
        <Container fluid>
          <Row>
            <Col>
              <Card className="scanner-card">
                <Card.Header style={{ backgroundColor: this.props.main_body }}>
                  <Row>
                    <Col
                      xl="5"
                      lg="5"
                      md="5"
                      sm="5"
                      xs="12"
                      className="d-flex align-items-center mt-2"
                    >
                      <h4 className="card-title">Verify Audit</h4>
                      <div style={{ marginLeft: 20 }}>
                        <Form.Control
                          as="select"
                          name="selectedLot"
                          placeholder="lot"
                          value={this.state.selectedLot}
                          className="photo-verify-form-control"
                          onChange={this.changeProperty}
                        >
                          <option value="">--Choose Lot--</option>
                          {(this.state.userlots ?? []).map((e, key) => {
                            return (
                              <option key={key} value={e.id}>
                                {e.alias}
                              </option>
                            );
                          })}
                        </Form.Control>
                        <span className={"help-block"}>
                          {this.state.lotSelectionError}
                        </span>
                      </div>
                    </Col>
                    <Col
                      xl="7"
                      lg="7"
                      md="7"
                      sm="7"
                      xs="12"
                      className="d-flex align-items-center mt-2"
                    >
                      <h4 className="card-title"> Stall </h4>
                      <div style={{ marginLeft: 20 }}>
                        <Form.Control
                          as="select"
                          name="selectedStall"
                          placeholder="stall"
                          value={this.state.selectedStall}
                          className="photo-verify-form-control"
                          onChange={this.changeStall}
                          disabled={stallDisabled}
                        >
                          <option value="">--All--</option>
                          {(this.state.stalls ?? []).map((e, key) => {
                            return (
                              e.stall_id !== null && (
                                <option key={key} value={e.stall_id}>
                                  {e.stall_id}
                                </option>
                              )
                            );
                          })}
                        </Form.Control>
                        <span className={"help-block"}></span>
                      </div>
                      {isQREnabled && (
                        <div>
                          <Button
                            onClick={() => this.openQrModal()}
                            disabled={!isScanEnabled}
                            className="ml-2"
                          >
                            Create QR Code
                          </Button>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Card.Header>
                <Card.Body>
                  {playSound && (
                    <div>
                      <audio
                        id="audio"
                        style={{ display: "none" }}
                        controls
                        autoPlay={true}
                        preload
                      >
                        <source
                          src={
                            verified ? audioFileAllowed : audioFileNotAllowed
                          }
                        ></source>
                      </audio>
                    </div>
                  )}

                  <Row>
                    <Col lg="12" className="pr-md-1 center scanned-image">
                      {isOpenCamera && (
                        <div>
                          {!loader && (
                            <>
                              {this.state.cameraError === "" ? (
                                <div class="position-relative d-inline-block">
                                  <Button
                                    className="position-absolute btn btn-danger btn-sm"
                                    style={{ top: "0", right: "0", zIndex: 5 }}
                                    variant="danger"
                                    onClick={() =>
                                      this.setState({
                                        isOpenCamera: !isOpenCamera,
                                      })
                                    }
                                  >
                                    <i
                                      className="fa fa-times"
                                      aria-hidden="true"
                                    ></i>
                                  </Button>
                                  <Camera
                                    onTakePhoto={(dataUri) => {
                                      this.handleTakePhoto(dataUri);
                                    }}
                                    // isImageMirror={true}
                                    idealFacingMode={FACING_MODES.ENVIRONMENT}
                                    isImageMirror={false}
                                    onCameraError={(error) => {
                                      this.handleCameraError(error);
                                    }}
                                    isDisplayStartCameraError={true}
                                  />
                                </div>
                              ) : (
                                <div
                                  style={{
                                    marginTop: "60px",
                                    marginBottom: "60px",
                                  }}
                                >
                                  <span>{this.state.cameraError}</span>
                                </div>
                              )}
                            </>
                          )}
                          {loader && (
                            <div className="loader">
                              <Loader />
                            </div>
                          )}
                        </div>
                      )}

                      <>
                        {!isOpenCamera && (
                          <img
                            src={image ? this.state.image : defaultImage}
                            alt=""
                            className="image-preview"
                            accept="image/*"
                          />
                        )}
                      </>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="5" md="6" sm="12" xs="12">
                      <Button
                        onClick={() => this.setState({ isOpenCamera: true })}
                        className="text-nowrap mr-2"
                        disabled={!isScanEnabled}
                      >
                        <img src={scan} width="18" />
                        {!isMobile && <span className="pl-2">Scan Plate</span>}
                      </Button>
                      <Button className="mr-2" onClick={this.redirectToTicket}>
                        <img src={ticket} width="18" />
                        {!isMobile && <span className="pl-2">Citation</span>}
                      </Button>
                      {"    "}
                    </Col>
                    <Col lg="6" md="6" sm="12" xs="12" className="mt-3 mt-md-0">
                      <div className="d-flex align-items-start">
                        <Button
                          type="button"
                          className="text-nowrap mr-2"
                          onClick={this.handlePlateCheck}
                          disabled={!isFormValid}
                        >
                          <img src={plate_check} width="18" />
                          {!isMobile && (
                            <span className="pl-2">Plate Check</span>
                          )}
                        </Button>
                        <div>
                          <Form.Control
                            placeholder="Enter plate number"
                            type="text"
                            name="lpn"
                            value={lpn}
                            autoComplete="off"
                            className="photo-verify-form-control"
                            onChange={(e) => this.handleChange(e)}
                          />
                          {validation_message(
                            lpn,
                            "Plate number",
                            validPlateNumber
                          )}
                        </div>
                      </div>
                    </Col>

                    {/*   <Col lg="3" className="pr-md-1 center responsive-mb-3">
                      <Button
                        type="button"
                        className="check-plate-input"
                        onClick={this.handlePlateCheck}
                        disabled={!isFormValid}
                      >
                        <img src={plate_check} width="18" />
                        {!isMobile && <span className="pl-2">Plate Check</span>}
                      </Button>
                    </Col> */}
                    {/*   <Col lg="3" className="pr-md-1 center responsive-mb-3">
                      <Button>
                        <img src={ticket} width="18" />
                        {!isMobile && <span className="pl-2">Ticket</span>}
                      </Button>
                    </Col> */}
                  </Row>
                </Card.Body>
              </Card>
              {show_error && (
                <CustomContentAlert
                  delay={4000}
                  message={api_error_message}
                  className="toast-error"
                />
              )}
            </Col>
          </Row>
          <Modal
            lg={"small"}
            show={this.state.showScanningModal}
            backdrop={"static"}
            dialogClassName="modal-90w"
            fullscreen={"sm-down"}
            className="scanner-modal"
          >
            <Card.Header className="d-flex justify-content-between bg-white align-items-center">
              <h4 className="m-0 font-weight-bold">
                <Card.Title className="m-0">Scan QR code</Card.Title>
              </h4>
              <Button
                title={"Deactivate"}
                type="button"
                onClick={() => this.closeQrModal()}
                className="close-btn py-0"
                data-dismiss="modal"
              >
                <i className="nc-icon nc-simple-remove text-danger" />
              </Button>
            </Card.Header>
            <ModalBody className="d-flex justify-content-center">
              <QRCode value={this.state.qrCodeUrl} />
            </ModalBody>
            <Modal.Footer></Modal.Footer>
          </Modal>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({
  UserProfileDetails,
  APIResponseDetails,
  EnforcementDetails,
  Logindetails,
}) => {
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  const { property_id: PropertyId, timezone, property } = UserProfileDetails;
  const { backgroundColor } = Logindetails;
  const { MainBackground: main_body } = backgroundColor;
  const { plateCheckData, extractedPlateNumber, userlots } = EnforcementDetails;
  return {
    api_response,
    api_error_message,
    api_success_message,
    PropertyId,
    timezone,
    property,
    plateCheckData,
    extractedPlateNumber,
    userlots,
    main_body,
  };
};

const mapStateToDispatch = {
  scanPlate: EnforcementActions.scanPlate,
  manuallyPlateCheck: EnforcementActions.manuallyPlateCheck,
  setDomainHeader: SuperAdminAction.setDomainHeader,
  getUserLots: EnforcementActions.get_user_lots,
};

export default connect(mapStateToProps, mapStateToDispatch)(Enforcement);
